export enum DateSelectionTypeEnum {
  Year,
  Month,
  Week,
  Range,
  Total,
}
